import { StateCreator } from "zustand";
import { RootStore } from "./";
import { SPATIAL_FILTER_TYPE } from "~map-view/types/__generated/gql/graphql";
import { Geometry } from "geojson";

export interface QueryState {
	currentSpatialType: SPATIAL_FILTER_TYPE | null;
	currentSpatialGeometry: Geometry | null;
}

export interface QueryActions {
	setCurrentSpatialType: (value: QueryState["currentSpatialType"]) => void;
	setCurrentSpatialGeometry: (
		value: QueryState["currentSpatialGeometry"],
	) => void;
}

export type QueryStore = QueryState & QueryActions;

export const createQuerySlice: StateCreator<RootStore, [], [], QueryStore> = (
	set,
) => ({
	currentSpatialType: null,
	currentSpatialGeometry: null,
	setCurrentSpatialType: (value) => set({ currentSpatialType: value }),
	setCurrentSpatialGeometry: (value) => set({ currentSpatialGeometry: value }),
});
